export function request(userId, value) {
    return {
        type: 'BETSLIP_REMOVE_MULTIPLE',
        userId,
        value
    };
}
